export default __webpack_public_path__ + "static/media/wireless.f45ffdf2.png";